import { el } from "./dom";
import {
  REQUIRED_MARKER_ARIA_LABEL,
  REQUIRED_MARKER_GLYPH,
  REQUIRED_MARKER_STYLE,
} from "../constants";
import type { PurposeItemData } from "../api/types";

/**
 * The red `*` that marks something the data subject cannot opt out of — a
 * required data element, or a purpose that carries one.
 *
 * Callers append this to the label element; append *after* any
 * `textContent` assignment, which replaces every existing child.
 */
export function createRequiredMarker(
  label: string = REQUIRED_MARKER_ARIA_LABEL
): HTMLElement {
  return el(
    "span",
    { style: REQUIRED_MARKER_STYLE, "aria-label": label },
    REQUIRED_MARKER_GLYPH
  );
}

/**
 * Whether a purpose carries at least one required data element — the condition
 * for marking the purpose itself as required in the notice UI.
 *
 * Deliberately does not also test `enabled`: this drives a visual marker, and
 * it must agree with the per-element markers actually on screen.
 */
export function hasRequiredDataElement(purpose: PurposeItemData): boolean {
  return purpose.data_elements.some((element) => element.required);
}
